import { useState } from "react"
import { TFilters } from "../../../../../components/TableDataGridV2/types"
import { Box, Button, Container, Grid, TextField } from "@mui/material"
import { permitirApenasNumeros } from "../../../../../helpers/masks"
import SelectLojaComPesquisa from "../../../../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa"

export default function PreFiltros({
    filtros,
    onSubmitFilters
}: PreFiltrosProps) {

    const [internFilters, setInternFilters] = useState(filtros)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('codigo_agronomo')) {
                novoObjeto.id_contem = [novoObjeto[key]];
                delete novoObjeto[key];
            }
            if (key.startsWith('loja_id')) {
                novoObjeto.loja_id_contem = [novoObjeto[key].id];
                delete novoObjeto[key];
            }

        });

        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onSubmitFilters(formatValue)
    }

    return (
        <Container maxWidth="md" sx={{pb: 2}}>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 6}}>
                <TextField
                        label="Código"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => { handleInsertFiltros("codigo_agronomo", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Nome"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => { handleInsertFiltros("nome_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Crea"
                        variant="outlined"
                        fullWidth
                        value={internFilters.numero_nf_maior_igual}
                        onChange={(e) => {
                            handleInsertFiltros("crea_pesquisar", permitirApenasNumeros(e.target.value))
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectLojaComPesquisa
                    value={internFilters.loja_id}
                    onChange={(valor) => handleInsertFiltros("loja_id", valor)}
                    />
                </Grid>
            </Grid>
            <Box mt={2}>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Pesquisar
                </Button>
            </Box>
        </Container>
    )
}

interface PreFiltrosProps {
    filtros: TFilters,
    onSubmitFilters: (args: TFilters) => void
}